/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 * @format
 * @flow
 */

import { all, takeLatest, put, takeEvery } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../../requests';
import { callAPI } from './callAPI';

export interface TableReceiptPrint {
  storeId: number;
  checkHeaderId: number;
  seatIds: Array<number>;
}

export function* tableReceiptPrint({ payload }: { payload: TableReceiptPrint }): any {
  yield callAPI(payload, ActionTypes.TABLE_RECEIPT_PRINT, API.tableReceiptPrint, false);
}

export default function* root(): any {
  yield all([
    takeEvery(ActionTypes.TABLE_RECEIPT_PRINT_REQUEST, tableReceiptPrint),
  ]);
}
